import KetExamListView from './component';

export default KetExamListView;



// WEBPACK FOOTER //
// ./containers/Group/KetExam/ListView/index.js